// Prefer absolute base from env; fall back to CRA proxy-style "/api"
const ENV_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, ""); // trim trailing slash
const BASE = ENV_BASE || "/api"; // if env not set, use /api (works with CRA proxy)

async function call(method, url, body, options = {}) {
  const path = `${BASE}${url.startsWith("/") ? url : `/${url}`}`; // safe join

  // Determine if body is FormData
  const isFormData = body instanceof FormData;

  // Build headers
  const headers = { ...options.headers };

  // Add authorization token from localStorage if available
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    try {
      const { token } = JSON.parse(userInfo);
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
    } catch (e) {
      // Invalid userInfo in localStorage, ignore
    }
  }

  // Only set Content-Type for JSON, let browser set it for FormData
  if (!isFormData && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(path, {
    method,
    headers,
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  });

  let json = null;
  try {
    json = await res.json();
  } catch {
    json = null;
  }

  if (!res.ok) {
    const msg = (json && (json.message || json.error)) || `${res.status} ${res.statusText}`;
    throw new Error(msg);
  }
  return json ?? {};
}

export const api = {
  get: (u) => call("GET", u),
  post: (u, b, opts) => call("POST", u, b, opts),
  put: (u, b, opts) => call("PUT", u, b, opts),
  delete: (u) => call("DELETE", u),
};
